var ezdia;
(function (ezdia) {
    // eslint-disable-next-line import/prefer-default-export
    function route() {
        var pathname = window.location.pathname;
        var method;
        var path = pathname.split('/').pop();
        switch (path) {
            case 'MyTask.htm':
                method = ezdia.pages.content.render.bind(ezdia.pages.content);
                break;
            case 'QueueManagement.htm':
                method = ezdia.pages.queueManagement.render.bind(ezdia.pages.queueManagement);
                break;
            case 'ExpertManagement.htm':
                method = ezdia.pages.content.render.bind(ezdia.pages.content, 'ExpertManagement');
                break;
            case 'ListOpenProjects.htm':
                method = ezdia.pages.openProjects.render.bind(ezdia.pages.openProjects);
                break;
            case 'MyOpenTask.htm':
                method = ezdia.pages.content.render.bind(ezdia.pages.content, 'MyOpenTask');
                break;
            // case 'ezaAlerts.htm':
            //   method = ezdia.pages.ezAnalyticsAlerts.render.bind(
            //     ezdia.pages.ezAnalyticsAlerts
            //   );
            //   break;
            default:
                break;
        }
        return method;
    }
    ezdia.route = route;
})(ezdia || (ezdia = {}));
